import { Stack, Tooltip } from "@mantine/core";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import { IconMessage } from "@tabler/icons-react";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import ModelSmvSelector from "../../../../../../components/Selectors/ModelSmvSelector";

const SmvNodeBody = ({ node_id, data }) => {
  const lang = useLanguage((s) => s.language);
  const updateNodeData = useFlowStore((s) => s.updateNodeData);
  const handleModelChange = (v) => {
    const newValue = v?.id ? parseInt(v?.id) : null;
    updateNodeData(node_id, {
      model_id: newValue,
    });
  };

  return (
    <Stack w={"100%"} pb={6} gap={"xs"}>
      <ModelSmvSelector
        value={data?.model_id}
        onChange={handleModelChange}
        required
        placeholder={lang.workflows.nodes.model_placeholder}
        size={"xs"}
        type={data?.actionType}
        leftSection={
          <Tooltip label={lang.campaign.selectors.email.tooltip}>
            <IconMessage size={16} strokeWidth={1.5} />
          </Tooltip>
        }
      />
    </Stack>
  );
};

export default SmvNodeBody;
